const PERMISSIONS_LIST = [
  "BUQUES_LIST",
  "BUQUES_READ",
  "BUQUES_CREATE",
  "BUQUES_UPDATE",
  "BUQUES_DELETE",
  "CATEADORES_LIST",
  "CATEADORES_READ",
  "CATEADORES_CREATE",
  "CATEADORES_UPDATE",
  "CATEADORES_DELETE",
  "CATEGORIAS_ESTABLECIMIENTO_LIST",
  "CATEGORIAS_ESTABLECIMIENTO_READ",
  "CATEGORIAS_ESTABLECIMIENTO_CREATE",
  "CATEGORIAS_ESTABLECIMIENTO_UPDATE",
  "CATEGORIAS_ESTABLECIMIENTO_DELETE",
  "CATEGORIA_MATERIAL_LIST",
  "CATEGORIA_MATERIAL_READ",
  "CATEGORIA_MATERIAL_CREATE",
  "CATEGORIA_MATERIAL_UPDATE",
  "CATEGORIA_MATERIAL_DELETE",
  "CATEOS_LIST",
  "CATEOS_READ",
  "CATEOS_CREATE",
  "CATEOS_UPDATE",
  "CATEOS_DELETE",
  "CERTIFICADO_LIST",
  "CERTIFICADO_READ",
  "CERTIFICADO_CREATE",
  "CERTIFICADO_UPDATE",
  "CERTIFICADO_DELETE",
  "COMPROBANTES_ACTUALIZAR",
  "COMPROBANTES_POST_PAGO",
  "COMPROBANTES_UPDATE",
  "COMPROBANTES_LIST",
  "COMPROBANTES_PUBLICAR_CPE",
  "COMPROBANTES_SIMULAR_PAGO",
  "DOMICILIOS_LIST",
  "DOMICILIOS_READ",
  "DOMICILIOS_CREATE",
  "DOMICILIOS_UPDATE",
  "DOMICILIOS_DELETE",
  "ESTABLECIMIENTO_MINERO_LIST",
  "ESTABLECIMIENTO_MINERO_READ",
  "ESTABLECIMIENTO_MINERO_CREATE",
  "ESTABLECIMIENTO_MINERO_UPDATE",
  "ESTABLECIMIENTO_MINERO_DELETE",
  "ESTABLECIMIENTO_NO_PRODUCTOR_LIST",
  "ESTABLECIMIENTO_NO_PRODUCTOR_READ",
  "ESTABLECIMIENTO_NO_PRODUCTOR_CREATE",
  "ESTABLECIMIENTO_NO_PRODUCTOR_UPDATE",
  "ESTABLECIMIENTO_NO_PRODUCTOR_DELETE",
  "GUIA_LIST",
  "GUIA_READ",
  "GUIA_CREATE",
  "INFORMACION_ADICIONALS_LIST",
  "INFORMACION_ADICIONALS_READ",
  "INFORMACION_ADICIONALS_CREATE",
  "INFORMACION_ADICIONALS_UPDATE",
  "INFORMACION_ADICIONALS_DELETE",
  "LOCALIDADES_LIST",
  "LOCALIDADES_READ",
  "MATERIAL_LIST",
  "MATERIAL_READ",
  "MATERIAL_CREATE",
  "MATERIAL_UPDATE",
  "MATERIAL_DELETE",
  "MINA_LIST",
  "MINA_READ",
  "MINA_CREATE",
  "MINA_UPDATE",
  "MINA_DELETE",
  "NO_PRODUCTORES_LIST",
  "NO_PRODUCTORES_READ",
  "NO_PRODUCTORES_CREATE",
  "NO_PRODUCTORES_UPDATE",
  "NO_PRODUCTORES_DELETE",
  "NO_PRODUCTORES_READ_MODULOS",
  "PADRON_DE_MINAS_LIST",
  "PADRON_DE_MINAS_READ",
  "PADRON_DE_MINAS_CREATE",
  "PADRON_DE_MINAS_UPDATE",
  "PADRON_DE_MINAS_DELETE",
  "PARAMETRO_LIST",
  "PARAMETRO_READ",
  "PARAMETRO_CREATE",
  "PARAMETRO_UPDATE",
  "PARAMETRO_DELETE",
  "PARTIDOS_LIST",
  "PARTIDOS_READ",
  "PERMISO_ESTABLECIMIENTO_MINERO_LIST",
  "PERMISO_ESTABLECIMIENTO_MINERO_READ",
  "PERMISO_ESTABLECIMIENTO_MINERO_CREATE",
  "PERMISO_ESTABLECIMIENTO_MINERO_UPDATE",
  "PERMISO_ESTABLECIMIENTO_MINERO_DELETE",
  "PERMISO_OFFLINE_LIST",
  "PERMISO_OFFLINE_READ",
  "PERMISO_OFFLINE_CREATE",
  "PERMISO_OFFLINE_UPDATE",
  "PERMISO_OFFLINE_DELETE",
  "PERMISSIONS_LIST",
  "PERMISSIONS_CREATE",
  "PERMISSIONS_READ",
  "PERMISSIONS_UPDATE",
  "PERMISSIONS_DELETE",
  "PRODUCTORES_MINEROS_LIST",
  "PRODUCTORES_MINEROS_READ",
  "PRODUCTORES_MINEROS_CREATE",
  "PRODUCTORES_MINEROS_UPDATE",
  "PRODUCTORES_MINEROS_DELETE",
  "PRODUCTORES_MINEROS_READ_MODULOS",
  "PROVINCIAS_LIST",
  "PROVINCIAS_READ",
  "ROLES_LIST",
  "ROLES_CREATE",
  "ROLES_READ",
  "ROLES_UPDATE",
  "ROLES_DELETE",
  "ROLES_PERMISSIONS",
  "RUTA_LIST",
  "RUTA_READ",
  "RUTA_CREATE",
  "RUTA_UPDATE",
  "RUTA_DELETE",
  "RUTA_TRANSITADA_LIST",
  "RUTA_TRANSITADA_READ",
  "RUTA_TRANSITADA_CREATE",
  "RUTA_TRANSITADA_UPDATE",
  "RUTA_TRANSITADA_DELETE",
  "TIPO_CERTIFICADO_LIST",
  "TIPO_CERTIFICADO_READ",
  "TIPO_CERTIFICADO_CREATE",
  "TIPO_CERTIFICADO_UPDATE",
  "TIPO_CERTIFICADO_DELETE",
  "TIPO_DESTINO_LIST",
  "TIPO_DESTINO_READ",
  "TIPO_DESTINO_CREATE",
  "TIPO_DESTINO_UPDATE",
  "TIPO_DESTINO_DELETE",
  "TIPO_DOCUMENTACION_RESPALDATORIA_LIST",
  "TIPO_DOCUMENTACION_RESPALDATORIA_READ",
  "TIPO_DOCUMENTACION_RESPALDATORIA_CREATE",
  "TIPO_DOCUMENTACION_RESPALDATORIA_UPDATE",
  "TIPO_DOCUMENTACION_RESPALDATORIA_DELETE",
  "TIPO_ESTABLECIMIENTO_MINERO_LIST",
  "TIPO_ESTABLECIMIENTO_MINERO_READ",
  "TIPO_ESTABLECIMIENTO_MINERO_CREATE",
  "TIPO_ESTABLECIMIENTO_MINERO_UPDATE",
  "TIPO_ESTABLECIMIENTO_MINERO_DELETE",
  "TIPO_ESTABLECIMIENTO_NO_PRODUCTOR_LIST",
  "TIPO_ESTABLECIMIENTO_NO_PRODUCTOR_READ",
  "TIPO_ESTABLECIMIENTO_NO_PRODUCTOR_CREATE",
  "TIPO_ESTABLECIMIENTO_NO_PRODUCTOR_UPDATE",
  "TIPO_ESTABLECIMIENTO_NO_PRODUCTOR_DELETE",
  "TIPO_IDENTIFICACION_LIST",
  "TIPO_IDENTIFICACION_READ",
  "TIPO_IDENTIFICACION_CREATE",
  "TIPO_IDENTIFICACION_UPDATE",
  "TIPO_IDENTIFICACION_DELETE",
  "TIPO_INFORMACION_ADICIONAL_LIST",
  "TIPO_INFORMACION_ADICIONAL_READ",
  "TIPO_INFORMACION_ADICIONAL_CREATE",
  "TIPO_INFORMACION_ADICIONAL_UPDATE",
  "TIPO_INFORMACION_ADICIONAL_DELETE",
  "TITULARES_LIST",
  "TITULARES_READ",
  "TITULARES_CREATE",
  "TITULARES_UPDATE",
  "TITULARES_DELETE",
  "TRANSPORTE_BUQUE_LIST",
  "TRANSPORTE_BUQUE_READ",
  "TRANSPORTE_BUQUE_CREATE",
  "TRANSPORTE_BUQUE_UPDATE",
  "TRANSPORTE_BUQUE_DELETE",
  "TRANSPORTE_CAMION_LIST",
  "TRANSPORTE_CAMION_READ",
  "TRANSPORTE_CAMION_CREATE",
  "TRANSPORTE_CAMION_UPDATE",
  "TRANSPORTE_CAMION_DELETE",
  "TRANSPORTE_TREN_LIST",
  "TRANSPORTE_TREN_READ",
  "TRANSPORTE_TREN_CREATE",
  "TRANSPORTE_TREN_UPDATE",
  "TRANSPORTE_TREN_DELETE",
  "UNIDAD_LIST",
  "UNIDAD_READ",
  "UNIDAD_CREATE",
  "UNIDAD_UPDATE",
  "UNIDAD_DELETE",
  "USERS_LIST",
  "USERS_CREATE",
  "USERS_READ",
  "USERS_UPDATE",
  "USERS_DELETE",
  "USERS_ROLES",
  "USERS_CREATE_ADMIN",
  "ESTABLECIMIENTO_MINERO_EXPORT",
  "ESTABLECIMIENTO_NO_PRODUCTOR_EXPORT",
  "MOVIMIENTOS_MODULO_LIST",
  "MOVIMIENTOS_MODULO_ADMIN_AGREGAR_MODULOS",
  "NO_PRODUCTORES_RECREAR_RENOVACION",
  "PADRON_DE_MINAS_EXPORT",
  "PADRON_DE_MINAS_RECREAR_RENOVACION",
  "PRODUCTORES_MINEROS_EXPORT",
  "PRODUCTORES_MINEROS_RECREAR_RENOVACION",
  "BUQUES_EXPORT",
  "CATEOS_EXPORT",
  "CONSECION_MINERA_LIST",
  "CONSECION_MINERA_READ",
  "CONSECION_MINERA_CREATE",
  "CONSECION_MINERA_UPDATE",
  "CONSECION_MINERA_DELETE",
  "CONSECION_MINERA_EXPORT",
  "GUIA_EXPORT",
  "NO_PRODUCTORES_EXPORT"
] as const;

type ToObj<K extends string> = {
  [P in K]: P;
};

export type PERMISSIONS_KEYS = (typeof PERMISSIONS_LIST)[number];

export type PERMISSIONS_ENUM = ToObj<PERMISSIONS_KEYS>;

export const PERMISSIONS = PERMISSIONS_LIST.reduce((acc, elem) => {
  return {
    ...acc,
    [elem]: elem
  };
}, {} as Record<PERMISSIONS_KEYS, PERMISSIONS_KEYS>);
